import { render } from "./Canvas.vue?vue&type=template&id=a8f9c8b2&scoped=true"
import script from "./Canvas.vue?vue&type=script&lang=js"
export * from "./Canvas.vue?vue&type=script&lang=js"

import "./Canvas.vue?vue&type=style&index=0&id=a8f9c8b2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-a8f9c8b2"

export default script